<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData">
      <template v-slot:conditionDto="update">
        <!--红包获取条件-->
        <condition :update="update"></condition>
      </template>
      <template v-slot:exchangeDto="update">
        <!--红包兑换条件-->
        <exchange :update="update"></exchange>
      </template>
    </UPDATE>

     <!--  上传用户  -->
    <UPDATE  ref="childUpdate1"  @submit="submit1" :updateData="updateData1" @uploadFile="uploadFile"/>

    <!--  黑名单  -->
    <UPDATE  ref="childUpdate2"  @submit="submit2" :updateData="updateData2" @uploadFile="uploadFile"/>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import URL from '@/views/crs36/util/url'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import condition from '@/views/crs36/luckyRedPacket/condition.vue'
  import exchange from '@/views/crs36/luckyRedPacket/exchange.vue'
  import Qs from 'qs'
  import axios from 'axios'
  let createList=[];
  let statusList={"1":$t("crs36.luckyRedPacket.status1"),"2":$t("crs36.luckyRedPacket.status2"),"3":$t("crs36.luckyRedPacket.status3"),"4":$t("crs36.luckyRedPacket.status4")}; //状态类型
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE,
      condition,
      exchange
    },
    methods: {
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
            //修改
          this.$refs.childUpdate.open(row);
          this.$refs.childTable.defaultGetData(this.queryData);
        }else if(clickName =="copy"){
            //复制
            this.$refs.childUpdate.open(row);
            row.id=null;
        }else if(clickName=="shenPi"){
            //审批
            this.$confirm($t("crs36.luckyRedPacket.textStatus"), $t("crs36.luckyRedPacket.tipStatus"), {
                confirmButtonText:  $t("crs36.luckyRedPacket.okStatus"),
                cancelButtonText:  $t("crs36.luckyRedPacket.offStatus"),
                type: 'warning'
            }).then(() => {
                this.$axios.get(URL.luckyRedPacket.updateStatus+"?id="+row.id).then(res=> {
                    if (res.code == 0) {
                        this.$message.success("suc");
                        this.$refs.childTable.defaultGetData(this.queryData);
                    }
                });
            });
        }else if(clickName=="addUser"){
            //导入参与用户
            this.$refs.childUpdate1.open(row);
        }else if(clickName=="black"){
            //导入黑名单
            this.$refs.childUpdate2.open(row);
        }else if(clickName=="stop"){
            //启用停用
            this.$confirm(row.status == 1 ? window.$t("crs.pushMsg.isStop"):window.$t("crs.pushMsg.isEnable"),  window.$t("common.tip"), {
                distinguishCancelAndClose: true,
                confirmButtonText: window.$t("common.ok"),
                cancelButtonText: window.$t("common.cancle")
            }).then(() => {
                this.$axios.get(URL.luckyRedPacket.stopStatus+"/"+row.id+"?value="+(row.status ==1 ? 2:1)).then(res=> {
                    if (res.code == 0) {
                        this.$message.success("suc");
                        this.$refs.childTable.defaultGetData(this.queryData);
                    }
                });
            })
        }else if(clickName == "info"){
            this.$router.push({path:"/crs36/luckyRedPacket/infoList", query: { activityId:row.id ,label:"CRS36"} })
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t("common.search") == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(data);
        }else if("+创建活动" == clickName   || window.$t("crs36.luckyRedPacket.create") == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
          if(model.conditionDto.type==null || model.conditionDto.type==undefined){
              this.$alert($t("crs36.luckyRedPacket.notIsEmp"), $t("crs36.luckyRedPacket.condition"), {
                  confirmButtonText: 'ok'
              });
              return;
          }
          if(model.conditionDto.result==null || model.conditionDto.result==undefined){
              this.$alert($t("crs36.luckyRedPacket.notIsEmp"), $t("crs36.luckyRedPacket.redPacket"), {
                  confirmButtonText: 'ok'
              });
          }
          if(model.exchangeDto.result==null || model.exchangeDto.result==undefined){
              this.$alert($t("crs36.luckyRedPacket.notIsEmp"), $t("crs36.luckyRedPacket.exchange"), {
                  confirmButtonText: 'ok'
              });
              return;
          }
          if(model.exchangeDto.type==null || model.exchangeDto.type==undefined){
              this.$alert($t("crs36.luckyRedPacket.notIsEmp"), $t("crs36.luckyRedPacket.get1"), {
                  confirmButtonText: 'ok'
              });
              return;
          }
        //根据是否包含id更新还是添加
        this.dataChanage((model.id!=undefined && model.id!=null && model.id!='') ? URL.luckyRedPacket.edit:URL.luckyRedPacket.save,model,res => {
          if (res.code == 0){
          this.$refs.childUpdate.close();
          this.$message.success("suc");
        }else{

        }
      })
      },
        //导入参与用户
      submit1(model){
          this.$axios.post(URL.luckyRedPacket.addUser,Qs.stringify({id:model.id,addUser:this.users})).then(res=> {
              if (res.code == 0) {
                  this.$message.success("suc");
                  this.$refs.childTable.defaultGetData(this.queryData);
                  this.$refs.childUpdate1.close();
              }
          });
       },
        //导入黑名单
      submit2(model){
            this.$axios.post(URL.luckyRedPacket.black,Qs.stringify({id:model.id,accounts:this.users})).then(res=> {
                if (res.code == 0) {
                    this.$message.success("suc");
                    this.$refs.childTable.defaultGetData(this.queryData);
                    this.$refs.childUpdate2.close();
                }
            });
        },
      dataChanage(url,option,suc,fail){
          this.$axios.post(url, option || {},{ headers: { 'Content-Type': 'application/json' } }).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      },uploadFile(col,res){
            // console.log(col,res);
            this.users = res.join(",");
        }
    },
    data () {
      return {
        deleteIds:"",
        users:"",
        queryData:{},
        /*新增或更新*/
        updateData:{

          cols:[
              { title: 'id', field: 'id',hidden:true},
              { title: 'status', field: 'status',hidden:true},
              { title: window.$t("crs36.luckyRedPacket.name"), field: 'name',required:true},
              { title: window.$t("crs36.luckyRedPacket.name1"), field: 'createTime',type:9,required:true,data:[]},
              { title: window.$t("crs36.luckyRedPacket.describe")+'en', field: 'describeEn',type:6},
              { title: window.$t("crs36.luckyRedPacket.describe")+'vn', field: 'describeVn',type:6},
              { title: '', field: 'conditionDto',type:10,required:true,slot:'conditionDto',optionList:{"1":"完成实名认证"},data:{type:"1"}},
              { title: '', field: 'exchangeDto',type:10,required:true,slot:'exchangeDto',optionList:{"1":"入金激活"},data:{type:"1"}},
              // { title: window.$t("crs36.luckyRedPacket.condition"), field: 'conditionDto.type',required:true,type:2,optionList:{"1":"完成实名认证"},data:"1",span:6},
              // { title: window.$t("crs36.luckyRedPacket.get"), field: 'conditionDto.result',required:true,type:7,span:18,text:"美元红包"},
              // { title: window.$t("crs36.luckyRedPacket.exchange"), field: 'exchangeDto.type',required:true,type:7,span:8,text:window.$t("crs36.luckyRedPacket.get1")},
              // { title: '', field: 'exchangeDto.result',type:2,optionList:{"1":"入金激活"},required:true,span:16,text:"",data:"1"},
              // { title: window.$t("crs36.luckyRedPacket.status"), field: 'status',type:3,required:true,optionList:{1:"启用",2:"禁用"},data:2,isNumber:true},
              ]
        },
        updateData1:{
          modelName:$t("crs36.luckyRedPacket.addUser"),
            cols:[
           {title:'id',field:'id',hidden:true},
           { title: window.$t("crs36.luckyRedPacket.addUser"), field: 'users',type:11,action:URL.pushMsg.uploadTemplate,downUrl:"https://static.chwenda.com/source/downloadModel/user_template.xlsx"},
        ]},updateData2:{
          modelName:$t("crs36.luckyRedPacket.black"),
            cols:[
                  {title:'id',field:'id',hidden:true},
                  { title: window.$t("crs36.luckyRedPacket.black"), field: 'users',type:11,action:URL.pushMsg.uploadTemplate,downUrl:"https://static.chwenda.com/source/downloadModel/user_template.xlsx"},
              ]
          },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: window.$t("crs36.luckyRedPacket.name"), field: 'name'},
              { title: window.$t("crs36.luckyRedPacket.status"),type:2,optionList:{"1":"已启用","2":"已停用","3":"已结束","4":"待审核"}, field: 'status'},
              { title: window.$t("crs36.luckyRedPacket.createName"), field: 'createName',type:2,optionList:createList},
              { title: window.$t("crs36.luckyRedPacket.createTime"), field: 'createTime',type:6},
              {click:window.$t("common.search"),auth:"sys:luckyRedPacket:find"},
              {click:window.$t("crs36.luckyRedPacket.create"),auth:"sys:luckyRedPacket:save"}

          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.luckyRedPacket.query, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
              { title: window.$t("crs36.luckyRedPacket.name"), field: 'name'},
              { title: window.$t("crs36.luckyRedPacket.startTime"), field: 'startTime'},
              { title: window.$t("crs36.luckyRedPacket.endTime"), field: 'endTime'},
              { title: window.$t("crs36.luckyRedPacket.status"), field: 'status',render:(data)=>{
                   return statusList[data] ;
                 }},
              { title: window.$t("crs36.luckyRedPacket.createName"), field: 'creatorName'},
              { title: window.$t("crs36.luckyRedPacket.createDate"), field: 'createDate'},
              { title: window.$t("crs36.luckyRedPacket.updateDate"), field: 'updateDate'},
              {title: window.$t("crs36.luckyRedPacket.sum"),field:"sum"},
              {title:window.$t("common.handle"),width:600,btnClick:[
                  {name:window.$t("crs36.luckyRedPacket.info"),click:"info",type:"primary",auth:"sys:luckyRedPacket:info"},
                  {name:window.$t("crs36.luckyRedPacket.copy"),click:"copy",type:"primary",auth:"sys:luckyRedPacket:copy"},
                  {name:window.$t("common.edit"),click:"update",type:"primary",auth:"sys:luckyRedPacket:edit"},
                  {name:window.$t("crs36.luckyRedPacket.shenPi"),hidden:(data,col)=>{
                              return col.status!=4;
                          },click:"shenPi",type:"primary",auth:"sys:luckyRedPacket:update"},
                  {name:(data,full)=>{
                          // console.log("full:"+JSON.stringify(full))
                          return full.status ==2 ? window.$t("common.start"):window.$t("common.stop");
                      },icon:(data,full)=>{
                          return full.status == 1 ? "el-icon-message-solid":"el-icon-bell";
                      },hidden:(data,col)=>{
                          if(((col.status ==1 || col.status ==2) && col.createTime[0]> Date.parse(new Date()))){
                              return false;
                          }
                          return true;
                      },click:"stop",type:"primary",auth:"sys:luckyRedPacket:stop"},
                  {name:window.$t("crs36.luckyRedPacket.black"),click:"black",type:"primary",auth:"sys:luckyRedPacket:black"},
                  {name:window.$t("crs36.luckyRedPacket.addUser"),click:"addUser",hidden:(data,col)=>{
                      // console.log("col:"+JSON.stringify(col))
                          return !(col.status==4 || col.createTime[0] > Date.parse(new Date()));
                      },type:"primary",auth:"sys:luckyRedPacket:addUser"},]},

          ]
        }
      }
    }
  }
</script>
